import { render, staticRenderFns } from "./AuditLogTableDensed.vue?vue&type=template&id=f490d5dc"
import script from "./AuditLogTableDensed.vue?vue&type=script&lang=ts"
export * from "./AuditLogTableDensed.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports